<div class="filter-container" *ngIf="status === 'success'" [@fadeInOut]>
  <ng-content></ng-content>
</div>
